module.exports = __webpack_public_path__ + "static/index/img/baikal-104.d03dac6e.jpg";